import '../AVIChartCommon.scss';
import './AVIDataCountTileFlex.scss';

import { AVIDashboardDimContext } from './AVIDashboardDimContext';
import { DimUtils } from '../ChartUtils/DimUtils';
import PropTypes from 'prop-types';
import React from 'react';

class AVIDataCountTileFlexBase extends React.Component {
  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    children: PropTypes.any,
    dims: PropTypes.object,
    title: PropTypes.string,
    useFlex: PropTypes.bool
  };

  static defaultProps = {
    width: 1,
    height: 1,
    useFlex: false
  };

  render () {
    const { children, title, width, height, dims, useFlex } = this.props;

    var hws = DimUtils.getDims(dims, width, height);
    let aviDataCountTileStyle = {};
    let aviDataCountContainerStyle = {};

    if (useFlex) {
      aviDataCountTileStyle = {
        width: '100%'
      };
      aviDataCountContainerStyle = {
        width: '100%'
      };
    } else {
      aviDataCountTileStyle = {
        marginLeft: hws.spacing,
        marginTop: hws.spacing
      };
      aviDataCountContainerStyle = {
        width: hws.width
      };
    }

    return (
      <div
        className='avi-data-count-tile-flex'
        style={aviDataCountTileStyle}
      >
        <h4>{title}</h4>
        <div
          className='avi-data-count-container-flex'
          style={aviDataCountContainerStyle}
        >
          {children}
        </div>
      </div>
    );
  }
}

export const AVIDataCountTileFlex = function (props) {
  return (
    <AVIDashboardDimContext.Consumer>
      {dims => <AVIDataCountTileFlexBase {...props} dims={dims} />}
    </AVIDashboardDimContext.Consumer>
  );
};

export default AVIDataCountTileFlex;
